import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['useInvoiceAddressAsDeliveryAddress', 'submit', 'email', 'emailAttachPdf']

  connect() {
    this.toggleAdditionalOptionsForDeliveryMethod()
    this.toggleDeliveryAddressFieldsVisibility(this.useInvoiceAddressAsDeliveryAddressTarget.checked)
  }

  emailChanged() {
    this.hasEmailChanged = true
  }

  async scanEmailAddress() {
    try {
      const response = await fetch(`/clients/scan_email_address?email=${encodeURIComponent(this.emailTarget.value)}`);
      const data = await response.json();

      if (data.scanning_central) {
        this.emailAddressIsForInvoiceScanningCentral = true;
      } else {
        this.emailAddressIsForInvoiceScanningCentral = false;
      }
    } catch (error) {
      this.emailAddressIsForInvoiceScanningCentral = false;
    }
  }

  async checkIfAutoCheckAttachPdf(event) {
    // As we are re-submitting if the user confirms we need to track if we have shown confirm.
    if (!this.userHasConfirmed) {
      if (!this.emailAttachPdfTarget.checked) {
        if (this.hasEmailChanged && this.emailTarget.value != "") {
          event.preventDefault();
          event.stopPropagation();
          await this.scanEmailAddress();
          if (this.emailAddressIsForInvoiceScanningCentral) {
            confirm = new Fakturan.Alert.Confirm ({ content: I18n.load('email_detected_as_invoice_scanning_central'),
              values: [
                {
                  title: I18n.load('yes'),
                  value: 'yes'
                },
                {
                  title: I18n.load('no'),
                  value: 'no',
                  classes: 'secondary'
                }]
              }, function(result) {
              if(result == 'yes') {
                // set the checkbox value for attach pdf
                this.emailAttachPdfTarget.click();
                this.userHasConfirmed = true;
                this.submitTarget.click();
              } else {
                this.userHasConfirmed = true;
                this.submitTarget.click();
              }
            }.bind(this));
            confirm.show();
          } else {
            this.userHasConfirmed = true;
            this.submitTarget.click();
          }
        }
      }
    }
  }

  toggleAdditionalOptionsForDeliveryMethod () {
    this.emailAttachPdf.hide()
    this.eInvoiceReference.hide()
    if (this.emailSelected || this.emailAndSmsSelected) {
      this.emailAttachPdf.show()
    } else if (this.eInvoiceSelected) {
      this.eInvoiceReference.show()
    }
  }

  toggleEInvoiceOption () {
    this.isPrivate ? this.hideEInvoiceOption() : this.showEInvoiceOption()
  }

  hideEInvoiceOption () {
    this.eInvoiceDeliveryMethodInput.hide()
    this.eInvoiceDeliveryMethodLabel.hide()
    if (this.eInvoiceSelected) {
      this.eInvoiceWasChecked = true
      this.emailDeliveryMethodOption.checked = true
    } else {
      this.eInvoiceWasChecked = false
    }
    this.toggleAdditionalOptionsForDeliveryMethod()
  }

  showEInvoiceOption () {
    this.eInvoiceDeliveryMethodInput.show()
    this.eInvoiceDeliveryMethodLabel.show()
    if (this.eInvoiceWasChecked) {
      this.eInvoiceDeliveryMethodOption.checked = true
    }
    this.toggleAdditionalOptionsForDeliveryMethod()
  }

  setAddressTabToInvoicing() {
    // used to make sure that the address invoice tab is shown, when changing org number
    this.changeTab(document.getElementById('link-tab-invoice-address'))
  }

  changeTab(tabHeaderElement) {
    // do nothing if click is same as active tab
    var deliveryTab = this.getDeliveryAddressTab()
    var invoiceTab = this.getInvoiceAddressTab()
    var activeTab = deliveryTab.classList.contains('hidden') ? invoiceTab : deliveryTab
    if (tabHeaderElement.id == 'link-tab-delivery-address') {
      if (activeTab == deliveryTab) {
        return
      }
    } else if (tabHeaderElement.id == 'link-tab-invoice-address') {
      if (activeTab == invoiceTab) {
        return
      }
    }
    // change style for tabs
    Array.from(tabHeaderElement.parentElement.parentElement.children).forEach( tabHeader => this.toggleActiveClass(tabHeader))
    this.getDeliveryAddressTab().classList.toggle('hidden')
    this.getInvoiceAddressTab().classList.toggle('hidden')
  }

  toggleActiveClass(element) {
    if (element.classList.contains('active')) {
      element.classList.remove('active')
    } else {
      element.classList.add('active')
    }
  }

  changeTabByClick(e) {
    this.changeTab(e.target)
  }

  toggleDeliveryAddressFieldsVisibility(checked) {
    if (checked) {
      if (!this.deliveryAddressFields.classList.contains('hidden')) {
        this.deliveryAddressFields.classList.add('hidden')
      }
    }
    else {
      if (this.deliveryAddressFields.classList.contains('hidden')) {
        this.deliveryAddressFields.classList.remove('hidden')
      }
    }
  }

  clickToggleDeliveryAddressFieldsVisibility(e) {
    this.toggleDeliveryAddressFieldsVisibility(e.target.checked)
  }

  getTabsMainElement() {
    return document.getElementById('address-tabs')
  }

  getDeliveryAddressTab() {
    return this.getTabsMainElement().getElementById('tab-delivery-address')
  }

  getInvoiceAddressTab() {
    return this.getTabsMainElement().getElementById('tab-invoice-address')
  }

  get deliveryAddressFields () {
    return $('delivery_address_fields')
  }

  get isPrivate () {
    return $('client_client_type_individual').checked
  }

  get eInvoiceSelected () {
    return $('client_settings_invoice_delivery_method_e_invoice').checked
  }

  get emailSelected () {
    return $('client_settings_invoice_delivery_method_email').checked
  }

  get emailAndSmsSelected () {
    return $('client_settings_invoice_delivery_method_email_and_sms').checked
  }

  get eInvoiceReference () {
    return $('e-invoice-reference')
  }

  get emailAttachPdf () {
    return $('setting-document_attach_pdf')
  }

  get eInvoiceDeliveryMethodInput () {
    return $('client_settings_invoice_delivery_method_e_invoice')
  }

  get eInvoiceDeliveryMethodLabel () {
    return $$('label[for=client_settings_invoice_delivery_method_e_invoice]')[0]
  }

  get eInvoiceDeliveryMethodOption () {
    return $('client_settings_invoice_delivery_method_e_invoice')
  }

  get emailDeliveryMethodOption () {
    return $('client_settings_invoice_delivery_method_email')
  }
}
